/**
 * Calculate Pearson correlation coefficient between two arrays
 * Returns a value between -1 and 1
 * 1 = perfect positive correlation
 * 0 = no correlation
 * -1 = perfect negative correlation
 */
export function calculateCorrelation(x, y) {
    if (!x || !y || x.length === 0 || y.length === 0 || x.length !== y.length) {
        return 0;
    }

    const n = x.length;
    
    // Calculate means
    const meanX = x.reduce((sum, val) => sum + val, 0) / n;
    const meanY = y.reduce((sum, val) => sum + val, 0) / n;
    
    // Calculate correlation coefficient
    let numerator = 0;
    let sumSquaredX = 0;
    let sumSquaredY = 0;
    
    for (let i = 0; i < n; i++) {
        const diffX = x[i] - meanX;
        const diffY = y[i] - meanY;
        numerator += diffX * diffY;
        sumSquaredX += diffX * diffX;
        sumSquaredY += diffY * diffY;
    }
    
    const denominator = Math.sqrt(sumSquaredX * sumSquaredY);
    
    if (denominator === 0) return 0;
    
    return numerator / denominator;
}

/**
 * Interpret correlation coefficient
 */
export function interpretCorrelation(r) {
    const absR = Math.abs(r);
    
    if (absR >= 0.9) return 'Very Strong';
    if (absR >= 0.7) return 'Strong';
    if (absR >= 0.5) return 'Moderate';
    if (absR >= 0.3) return 'Weak';
    return 'Very Weak';
}

/**
 * Get color based on correlation strength
 */
export function getCorrelationColor(r) {
    const absR = Math.abs(r);
    
    if (absR >= 0.7) return '#10b981'; // Green - strong
    if (absR >= 0.5) return '#3b82f6'; // Blue - moderate
    if (absR >= 0.3) return '#f59e0b'; // Orange - weak
    return '#94a3b8'; // Gray - very weak
}

